/* eslint-disable camelcase */
export default ({ data }) => {
  const groupsData = { ...data.data };

  const users = groupsData.users.map(({ avatar_path, ...user }) => ({
    avatar: avatar_path,
    ...user,
  }));

  return { ...groupsData, users };
};
